import React, { FC } from 'react';
import { LiveTableProps } from "../../types";
import { TableContainer } from "../../../detalhamentoSLC/pagamentos/styles";
import Table, { TableColumn } from "../../../../components/Table";
import { formatBrandCodeView, formatDateView, formatDocument, formatMoneyCentsView } from "../../../../utils/formatViews";

export const LiveTable: FC<LiveTableProps> = (
  {
    data,
    currentPage,
    pageSize,
    onPageChange,
    onPageSizeChange}) => {

  return (
    <div>
      <TableContainer>
        <Table
          dataSource={data.records}
          pagination={
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} pagamentos`,
            }}
        >
          <TableColumn title="Data Recebimento" dataIndex="receiveDate" key="brand" render={formatDateView} />
          <TableColumn title="Cód. Lojista" dataIndex="merchantId" key="merchantId" />
          <TableColumn title="Nome do titular" dataIndex="holderName" key="holderName" />
          <TableColumn title="Valor pago" dataIndex="paymentValue" key="paymentValue" render={formatMoneyCentsView}/>
          <TableColumn title="Valor descontado" dataIndex="discountedValue" key="discountedValue" render={formatMoneyCentsView}/>
          <TableColumn title="Tipo Conta" dataIndex="accountType" key="accountType" />
          <TableColumn title="Banco" dataIndex="bankCode" key="bankCode" />
          <TableColumn title="Agência" dataIndex="bankBranch" key="bankBranch" />
          <TableColumn title="Conta bancária" dataIndex="bankAccount" key="bankAccount" />
          <TableColumn title="Bandeira" dataIndex="brandCode" key="brandCode" render={formatBrandCodeView} />
          <TableColumn title="Documento Cliente" dataIndex="customerDocument" key="customerDocument" render={formatDocument}/>
        </Table>
      </TableContainer>
    </div>
  )
}
